import { logAppError } from 'Helpers/logger'
import getIntl from 'Helpers/intl'

import { pageState, previewCardState, previewsListState, previewsPollingState } from '../state/page'
import { getAccountLimits, getMessGetMessageDetails, isSendingMessage } from '../actions/actions'
import {
  beEmailCheckupGetEOAClients,
  beEmailCheckupGetMessagePreviews,
  beEmailCheckupRetryGetMessagePreview
} from 'Api/beEmailCheckupApi'
import { FULL_VIEW } from '../../const'

export const initCallback = ({ snapshot, set }) => async (idMessage) => {
  set(pageState, prev => ({
    ...prev,
    loaded: false,
    loading: true,
    error: false
  }))

  try {
    const { Subject, IsBee: isBee, MessageType: messageType } = await getMessGetMessageDetails(idMessage)
    const maxState = await getAccountLimits()
    const isSending = await isSendingMessage(idMessage)
    const clients = await beEmailCheckupGetEOAClients()

    set(pageState, prev => ({
      ...prev,
      loaded: true,
      pageTitle: Subject,
      maxState,
      isSending,
      isBee,
      messageType
    }))

    const clientIds = []

    clients.forEach(e => {
      clientIds.push(e.Id)

      set(previewCardState(e.Id), prev => ({
        ...prev,
        id: e.Id,
        category: e.Category,
        displayName: e.DisplayName,
        operativeSystem: e.OperativeSystem,
        browser: e.Browser
      }))
    })

    set(pageState, prev => ({
      ...prev,
      clientsIdList: clientIds
    }))
  } catch (error) {
    logAppError({
      appError: error
    })
    set(pageState, prev => ({
      ...prev,
      error: getIntl().formatMessage({ id: 'Load.Alerts.ErrorGeneric' }),
      severity: 'danger'
    }))
  }

  set(pageState, prev => ({
    ...prev,
    loading: false
  }))
}

export const initPreviewsCallback = ({ set }) => async (idMessage, viewType) => {
  set(previewsListState, prev => ({
    ...prev,
    loaded: false,
    loading: true
  }))
  const data = {
    TestType: viewType === FULL_VIEW ? 'Full' : 'Free'
  }

  try {
    const previews = await beEmailCheckupGetMessagePreviews(idMessage, data)
    const previewIds = []
    let pendingElements = []
    if (previews && previews.length > 0) {
      previews.forEach(m => {
        previewIds.push(m.Id)
        set(previewCardState(m.Id), prev => ({
          ...prev,
          status: m.Status,
          thumbnailImagePath: m.ThumbnailImagePath,
          previewImagePath: m.PreviewImagePath,
          loaded: true
        }))
      })
      pendingElements = previews.filter(m => (m.Status === 'Pending' || m.Status === 'Processing'))
    }
    if (!previews || previews.length === 0 || pendingElements.length > 0) {
      // if I don't receive yet any preview I start polling, as when I receive any preview in 'pending' status
      set(previewsPollingState, prev => ({
        ...prev,
        polling: true,
      }))
    }
    set(previewsListState, prev => ({
      ...prev,
      previewsIdList: previewIds
    }))
  } catch (error) {
    logAppError({
      appError: error
    })
    set(pageState, prev => ({
      ...prev,
      error: getIntl().formatMessage({ id: 'Load.Alerts.ErrorGeneric' }),
      severity: 'danger'
    }))
  }

  set(previewsListState, prev => ({
    ...prev,
    loading: false,
    loaded: true
  }))
}

export const pollPreviewsCallback = ({ set, snapshot }) => async (idMessage, viewType) => {
  const data = {
    TestType: viewType === FULL_VIEW ? 'Full' : 'Free'
  }
  const { pollingIteration, polling, pollingInterval } = await snapshot.getPromise(previewsPollingState)
  let pendingElements = []
  try {
    const previews = await beEmailCheckupGetMessagePreviews(idMessage, data)
    if (previews && previews.length > 0) {
      previews.forEach(m => {
        set(previewCardState(m.Id), prev => ({
          ...prev,
          status: m.Status,
          thumbnailImagePath: m.ThumbnailImagePath,
          previewImagePath: m.PreviewImagePath,
          loaded: true
        }))
      })
      pendingElements = previews.filter(m => (m.Status === 'Pending' || m.Status === 'Processing'))
    }

    if (!previews || previews.length === 0 || pendingElements.length > 0) {
      if (!polling) {
        set(previewsPollingState, prev => ({
          ...prev,
          polling: true,
          pollingIteration: pollingIteration + 1,
          pollingInterval: pollingInterval < 10000 ? pollingInterval + 1000 : pollingInterval
        }))
      } else {
        set(previewsPollingState, prev => ({
          ...prev,
          pollingIteration: pollingIteration + 1,
          pollingInterval: pollingInterval < 10000 ? pollingInterval + 1000 : pollingInterval
        }))
      }

    } else {
      set(previewsPollingState, prev => ({
        ...prev,
        polling: false,
        pollingIteration: 0,
        pollingInterval: 3000
      }))
    }

  } catch (error) {
    logAppError({
      appError: error
    })
  }
}

export const retryPreviewsCallback = ({ set, snapshot }) => async (idMessage, viewType) => {
  const data = {
    TestType: viewType === FULL_VIEW ? 'Full' : 'Free'
  }
  set(previewsPollingState, prev => ({
    ...prev,
    pollingIteration: 0
  }))
  const { previewsIdList } = await snapshot.getPromise(previewsListState)
  for (let i = 0; i < previewsIdList.length; i++) {
    const card = await snapshot.getPromise(previewCardState(previewsIdList[i]))
    if (card.status === 'Error') {
      set(previewCardState(previewsIdList[i]), prev => ({
        ...prev,
        status: 'Pending'
      }))
    }
  }

  try {
    const { Result } = await beEmailCheckupRetryGetMessagePreview(idMessage, data)

    if (Result) {
      set(previewsPollingState, prev => ({
        ...prev,
        polling: true,
        pollingInterval: 3000
      }))
    }
  } catch (error) {
    logAppError({
      appError: error
    })
  }
}
